<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Medical Information</v-toolbar-title>
            <v-spacer></v-spacer>
            <!--<v-btn icon>-->
            <!--<v-icon class="icon-light" @click="save">save</v-icon>-->
            <!--</v-btn>-->
            <v-btn flat @click="save">
                save
            </v-btn>
            <v-tabs slot="extension" v-model="tab" color="transparent" grow>
                <v-tabs-slider color="#a8cf45"></v-tabs-slider>

                <v-tab key="medical">Medical</v-tab>
                <v-tab key="social">Social</v-tab>
            </v-tabs>
        </v-toolbar>
        <v-content>
            <v-form lazy-validation ref="form" style="width: 100%">
                <v-tabs-items v-model="tab">
                    <v-tab-item key="medical">
                        <v-container color="transparent">
                            <v-layout row full-width>
                                <v-flex xs-12>
                                    <v-text-field label="Allergies" v-model="user.allergies"></v-text-field>

                                    <v-text-field label="Chronic Diseases" v-model="user.diseases"></v-text-field>

                                    <v-select placeholder="Blood Group" :items="bloodGroups" v-model="user.bloodGroup"/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item key="social">
                        <v-container color="transparent">
                            <v-layout row full-width>
                                <v-flex xs-12>
                                    <v-text-field label="Number of Dependants" type="number" v-model="user.dependancies"/>

                                    <v-select label="Are You a Smoker?" :items="['Yes', 'No']" v-model="user.smoker"/>
                                    <v-select label="Do You Drink Alchohol?" :items="['Yes', 'No']" v-model="user.drinker"/>
                                    <v-select label="Are you pregnant?" :items="['Yes', 'No']" v-model="user.pregnant"/>

                                    <v-text-field label="I.C.E (in case of emergency) #1" type="telephone" v-model="user.ice1" :rules="[rules.cellphone]"/>
                                    <v-text-field label="I.C.E (in case of emergency) #2" type="telephone" v-model="user.ice2" :rules="[rules.cellphone]"/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-form>

            <v-footer app v-if="false">
                <v-spacer></v-spacer>
                <v-btn color="primary" flat small class="text-xs-right" @click="save">
                    Save
                </v-btn>
            </v-footer>
        </v-content>
        <v-snackbar
                v-model="snackbar.visible"
                :bottom="true"
                :left="false"
                :multi-line="false"
                :right="false"
                :timeout="5000"
                :top="false"
                :vertical="false">

            {{ snackbar.message }}

            <v-btn flat @click="snackbar.visible = false">
                Close
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
    import vas from "@/lib/VASClient"
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                tab: null,
                bloodGroups: null,
                snackbar: {
                    visible: false,
                    message: '',
                },
                user: {
                    allergies: null,
                    diseases: null,
                    bloodGroup: null,
                    dependancies: null,
                    smoker: null,
                    drinker: null,
                    pregnant: null,
                    ice1: null,
                    ice2: null
                },
                rules: {
                    cellphone(value) {
                        if (value == null || value == '') {
                            return true;
                        }

                        var message = 'Please enter a valid cellphone number';

                        if (isNaN(value)) {
                            return message;
                        }

                        if (value.length < 10 || value.length > 12) {
                            return message;
                        }

                        if (value[0] !== '0' && (value[0] + value[1]) != '27') {
                            return message;
                        }

                        return true;
                    }
                }
            }
        },
        created() {
            this.bloodGroups = vas.getBloodGroups();

            this.user.allergies = this.auth.user.allergies;
            this.user.diseases = this.auth.user.illness;
            this.user.bloodGroup = this.auth.user.blood_type;
            this.user.dependancies = this.auth.user.dependents;
            this.user.smoker = this.auth.user.smoker;
            this.user.drinker = this.auth.user.drinker;
            this.user.pregnant = this.auth.user.pregnant;
            this.user.ice1 = this.auth.user.ice1;
            this.user.ice2 = this.auth.user.ice2;
        },
        methods: {
            showSnackbar(message) {
                this.snackbar.message = message;
                this.snackbar.visible = true;
            },
            save() {
                if (!this.$refs.form.validate()) {
                    this.showSnackbar('Some of your data entered is invalid. Please correct the highlighted fields');

                    return;
                }

                var self = this;

                Loading.show('');

                vas.updateInfo(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.auth.user.age,
                    this.auth.user.sex,
                    this.auth.user.race,
                    this.user.pregnant,
                    this.auth.user.weight,
                    this.auth.user.height,
                    this.user.smoker,
                    this.user.drinker,
                    this.user.bloodGroup,
                    this.user.diseases,
                    this.user.allergies,
                    this.auth.user.home_address_1,
                    this.auth.user.home_address_2,
                    this.auth.user.home_suburb,
                    this.auth.user.home_province,
                    this.auth.user.home_postal_code,
                    this.user.dependancies,
                    this.user.ice1,
                    this.user.ice2,
                    this.auth.user.name,
                    this.auth.user.surname,
                    this.auth.user.language_id,
                    '')
                    .then(function (response) {
                            self.auth.user.pregnant = self.user.pregnant;
                            self.auth.user.smoker = self.user.drinker;
                            self.auth.user.drinker = self.user.pregnant;
                            self.auth.user.blood_type = self.user.bloodGroup;
                            self.auth.user.illness = self.user.diseases;
                            self.auth.user.allergies = self.user.allergies;
                            self.auth.user.dependents = self.user.dependancies;
                            self.auth.user.ice1 = self.user.ice1;
                            self.auth.user.ice2 = self.user.ice2;

                            self.$store.commit('auth/login', {user:self.auth.user});

                            self.showSnackbar('Your medical information has been updated');

                            Loading.hide();
                        }
                    );
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>